import { api } from "./client";

export interface RouletteRewardPreview {
  type: "gold" | "diamonds" | "consumable" | "mount_stones" | "mount_card" | "gem";
  amount?: number | null;
  item_id?: string | null;
  quantity?: number | null;
  mount_code?: string | null;
  gem_type?: string | null;
  level?: number | null;
  label: string;
  icon_hint: string;
}

export interface RouletteSegmentPreview {
  slot: number;
  reward_preview: RouletteRewardPreview;
}

export interface RouletteSpinCost {
  type: "consumable" | "gold" | "diamonds";
  item_id?: string | null;
  amount: number;
}

export interface RouletteStatus {
  active: boolean;
  active_until: string | null;
  segments: RouletteSegmentPreview[];
  spin_cost: RouletteSpinCost;
  cost_available: number;
}

export interface RouletteSpinResult {
  winning_slot_index: number;
  reward: RouletteRewardPreview;
  message: string;
  cost_available: number;
}

export interface RouletteRewardConfig {
  type: "gold" | "diamonds" | "consumable" | "mount_stones" | "mount_card" | "gem";
  amount?: number | null;
  item_id?: string | null;
  quantity?: number | null;
  mount_code?: string | null;
  gem_type?: string | null;
  level?: number | null;
}

export interface RouletteSegmentConfig {
  slot: number;
  weight: number;
  reward: RouletteRewardConfig;
}

export interface RouletteAdminConfig {
  active: boolean;
  active_until: string | null;
  spin_cost: RouletteSpinCost;
  segments: RouletteSegmentConfig[];
}

export const rouletteApi = {
  getStatus: () => api.get<RouletteStatus>("/roulette/status"),
  spin: () => api.post<RouletteSpinResult>("/roulette/spin"),
};
